export default class ProgressBar {
  constructor(element) {
    this.element = element;
    this.value = this.getValue();
    this.fill = this.element.querySelector('[data-progress-fill]');
    this.label = this.element.querySelector('[data-progress-label]');
    this.hasAnimated = false;

    this.init();
  }

  getValue() {
    const rawValue = this.element.dataset.progressValue || this.element.dataset.progress || '0';
    const value = Number.parseFloat(rawValue);

    return Number.isFinite(value) ? Math.min(100, Math.max(0, value)) : 0;
  }

  init() {
    this.element.style.setProperty('--progress-value', `${this.value}%`);
    this.element.setAttribute('aria-valuemin', '0');
    this.element.setAttribute('aria-valuemax', '100');
    this.element.setAttribute('aria-valuenow', String(this.value));

    if (this.label) {
      this.label.textContent = `${Math.round(this.value)}%`;
    }

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.animate();
            this.observer.disconnect();
          }
        });
      }, { threshold: 0.35 });

      this.observer.observe(this.element);
      return;
    }

    this.animate();
  }

  animate() {
    if (this.hasAnimated) {
      return;
    }

    this.hasAnimated = true;

    requestAnimationFrame(() => {
      this.element.classList.add('is-animated');
    });
  }
}
